import { takeLatest, put, call } from 'redux-saga/effects';
import {
  GET_WEBPAY_TOKEN,
  WEBPAY_TOKEN,
  SET_SPINNER,
} from '../../state/webpay/types';
import { CLEAR_ERRORS, FETCH_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';
import {
  webpayToken
} from '../../network/webpay';

function* getWebpayToken(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(webpayToken, payload);
    yield put({ type: WEBPAY_TOKEN, payload: data });
    yield put({ type: CLEAR_ERRORS });
    yield put({ type: SET_SPINNER, payload: false });
  } catch (e) {
    yield put({ type: SET_SPINNER, payload: false });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response.status || 500,
      }
    });
  }
};

function* watchGetWebpayToken() {
  yield takeLatest(GET_WEBPAY_TOKEN, getWebpayToken);
}

export default [
  watchGetWebpayToken(),
];